import { useEffect, useState } from 'react'
import { useEsri } from '../../esriHooks'

const esriReqs = ['esri/Graphic', 'esri/layers/GraphicsLayer']

const GraphicLayer = ({
  id,
  map,
  view,
  graphics,
  onSelect,
  onDeselect,
  onClick,
}) => {
  const [ready, { Graphic, GraphicsLayer }] = useEsri(esriReqs)
  const [layer, setLayer] = useState(null)
  const [layerId] = useState(id || '')

  useEffect(() => {
    if (ready && map) {
      const newLayer = new GraphicsLayer()
      map.add(newLayer)
      setLayer(newLayer)
    }
  }, [ready, GraphicsLayer, map])

  // Refresh graphics when data changes
  useEffect(() => {
    if (layer && Graphic && graphics) {
      const newGraphics = graphics.map(
        (graphic) =>
          new Graphic({
            geometry: graphic.geometry,
            symbol: graphic.symbol,
            attributes: {
              data: graphic,
              layerId,
            },
          })
      )
      layer.removeAll()
      layer.addMany(newGraphics)
      //console.log('Graphics Layer Updated', layerId, newGraphics)
    }
  }, [layer, Graphic, layerId, graphics])

  // Set on click handler for layer
  useEffect(() => {
    if (view) {
      const handler = view.on('click', (event) => {
        const screenPoint = {
          x: event.x,
          y: event.y,
        }

        onClick && onClick(event.mapPoint.longitude, event.mapPoint.latitude)

        view.hitTest(screenPoint).then((response) => {
          // Select data when you click on a graphic
          if (response.results.length) {
            const matching = response.results.filter(
              (result) =>
                result &&
                result.graphic &&
                result.graphic.attributes &&
                result.graphic.attributes.layerId === layerId
            )
            if (matching.length) {
              onSelect &&
                onSelect(
                  matching.map((result) => result.graphic.attributes.data)
                )
            }
          } else {
            // Or deselect data when you click elsewhere
            onDeselect && onDeselect()
          }
        })
      })
      return handler.remove
    }
  }, [view, onSelect, onDeselect, onClick, layerId])

  return null
}

export default GraphicLayer
